import * as tslib_1 from "tslib";
import selectSurfaceActionsOption from '../actions/selectSurfaceActionsOption';
import store from '../store/store';
import { ExtensibilityModeEnum } from 'owa-addins-types';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { getFallbackValueIfNull } from 'owa-options-core';
import strings from 'owa-strings/owa-options-strings';
import SurfaceActionsShared from 'owa-surface-actions-view/lib/components/SurfaceActionsShared';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import { getOptionsForFeature, OwsOptionsFeatureType, } from 'owa-outlook-service-options';
import { getComposeStaticActions, getReadStaticActions, getReadActionDisplayName, getComposeActionDisplayName, getReadActionIconName, getComposeActionIconName, getAddinCollection, } from 'owa-surface-actions';
var ABSTRACT_COMPOSE_SVG = require('./svg/abstractCompose.svg');
var ABSTRACT_ITEM_PART_SVG = require('./svg/abstractItemPart.svg');
var styles = require('./MailSurfaceActions.scss');
var MailSurfaceActions = /** @class */ (function (_super) {
    tslib_1.__extends(MailSurfaceActions, _super);
    function MailSurfaceActions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MailSurfaceActions.prototype.render = function () {
        var _a = this.props, isCompose = _a.isCompose, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var actions = [];
        var addins = [];
        var selectedActions = [];
        var selectedAddins = [];
        var onActionSelected;
        var onAddinSelected;
        var actionDisplayNameGetter;
        var actionIconNameGetter;
        var previewImageUri;
        var previewClassName;
        var description;
        var extMode;
        if (isCompose) {
            actions = getComposeStaticActions().map(function (a) { return a.key; });
            extMode = ExtensibilityModeEnum.MessageCompose;
            // Get action/addin arrays and slice them to create a copy so we don't modify the real data.
            selectedActions = getFallbackValueIfNull(optionStore.composeSurfaceActions, userOptions.composeSurfaceActions).slice();
            selectedAddins = getFallbackValueIfNull(optionStore.composeSurfaceAddins, userOptions.composeSurfaceAddins).slice();
            onActionSelected = function (actionCollection, actionKey, isSelected) {
                selectSurfaceActionsOption('composeSurfaceActions', actionCollection, actionKey, isSelected);
            };
            onAddinSelected = function (addinCollection, addinKey, isSelected) {
                selectSurfaceActionsOption('composeSurfaceAddins', addinCollection, addinKey, isSelected);
            };
            actionDisplayNameGetter = getComposeActionDisplayName;
            actionIconNameGetter = getComposeActionIconName;
            previewImageUri = ABSTRACT_COMPOSE_SVG;
            previewClassName = styles.composePreview;
            description = strings.options_composeSurfaceActions_description;
        }
        else {
            actions = getReadStaticActions().map(function (a) { return a.key; });
            extMode = ExtensibilityModeEnum.MessageRead;
            // Get action/addin arrays and slice them to create a copy so we don't modify the real data.
            selectedActions = getFallbackValueIfNull(optionStore.readSurfaceActions, userOptions.readSurfaceActions).slice();
            selectedAddins = getFallbackValueIfNull(optionStore.readSurfaceAddins, userOptions.readSurfaceAddins).slice();
            onActionSelected = function (actionCollection, actionKey, isSelected) {
                selectSurfaceActionsOption('readSurfaceActions', actionCollection, actionKey, isSelected);
            };
            onAddinSelected = function (addinCollection, addinKey, isSelected) {
                selectSurfaceActionsOption('readSurfaceAddins', addinCollection, addinKey, isSelected);
            };
            actionDisplayNameGetter = getReadActionDisplayName;
            actionIconNameGetter = getReadActionIconName;
            previewImageUri = ABSTRACT_ITEM_PART_SVG;
            previewClassName = styles.readingPanePreview;
            description = strings.options_readSurfaceActions_description;
        }
        if (isMailFeatureEnabled('rp-addins')) {
            var addinCollection = getAddinCollection(extMode);
            addins = addinCollection ? addinCollection.sectionProps.items : [];
        }
        return (React.createElement("div", null,
            React.createElement(SurfaceActionsShared, { actions: actions, addins: addins, selectedActions: selectedActions, selectedAddins: selectedAddins, onActionSelected: onActionSelected, onAddinSelected: onAddinSelected, getDisplayNameFromAction: actionDisplayNameGetter, getIconNameFromAction: actionIconNameGetter, isLeftToRight: isCompose, previewImageUri: previewImageUri, previewClassName: previewClassName, description: description })));
    };
    MailSurfaceActions = tslib_1.__decorate([
        reactive({
            optionStore: function () { return store; },
            userOptions: function () {
                return getOptionsForFeature(OwsOptionsFeatureType.SurfaceActions);
            },
        })
    ], MailSurfaceActions);
    return MailSurfaceActions;
}(React.Component));
export default MailSurfaceActions;
//# sourceMappingURL=MailSurfaceActions.js.map